import { render, staticRenderFns } from "./GraphqlPopup.vue?vue&type=template&id=1e706c84&"
import script from "./GraphqlPopup.vue?vue&type=script&lang=js&"
export * from "./GraphqlPopup.vue?vue&type=script&lang=js&"
import style0 from "./GraphqlPopup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports